module.exports = __webpack_public_path__ + "img/deafault.214df55f.jpg";